import { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import Select from "react-select"
import LoadingModal from "../../../components/loadingModal"
import dayjs from "dayjs"
import InsumosFiltroPeriodo from "./FiltroPeriodo"
import { ApiEndpoints, reqGetNew, reqPostNew } from "../../../config/apiClient"
import { createColumnHelper } from "@tanstack/react-table"
import DataTable from "../../../components/dataTable/DataTable"
import InsumosModalPedido from "./ModalPedido"
import { getUrlSearchParams } from "../../urlParams"
import InsumosModalCriarPedido from "./ModalCriarPedido"

export default function InsumosPedidosPage() {
    const [loading, setLoading] = useState<boolean>(false)
    const [pedidos, setPedidos] = useState<any[]>([])
    const [showModalPedido, setShowModalPedido] = useState<boolean>(false)
    const [showModalCriarPedido, setShowModalCriarPedido] = useState<boolean>(false)
    const [pedidoModal, setPedidoModal] = useState<any>({})

    const DATA_ATUAL = dayjs()
    const [competencias, setCompetencias] = useState<any>({
        value: DATA_ATUAL.format("YYYY-MM"),
        label: DATA_ATUAL.format("MM/YYYY"),
    })

    const [filtrosDados, setFiltroDados] = useState<any>({})
    const [statusFiltro, setStatusFiltro] = useState<any>([])
    const [statusFiltroSelected, setStatusFiltroSelected] = useState<any>([])
    const [locaisFiltro, setLocaisFiltro] = useState<any>([])
    const [locaisFiltroSelected, setLocaisFiltroSelected] = useState<any>([])
    const [colaboradoresFiltro, setColaboradoresFiltro] = useState<any[]>([])
    const [colaboradoresFiltroSelected, setColaboradoresFiltroSelected] = useState<any[]>([])

    const [produtosOptions, setProdutosOptions] = useState<any[]>([])
    const [unidadesOptions, setUnidadesOptions] = useState<any[]>([])

    useEffect(() => {
        document.title = "Insumos Pedidos | OB PORTUS"
        loadingPage()
        const loadOptions = async () => {
            const apiProdutos = await reqGetNew(ApiEndpoints.insumosProdutos)
            const apiUnidades = await reqGetNew(ApiEndpoints.insumosUnidades)
            const apiLocais = await reqGetNew(ApiEndpoints.insumosLocais)
            if (apiProdutos.status !== 200 || apiUnidades.status !== 200 || apiLocais.status !== 200) {
                return
            }
            
            let produtos = apiProdutos.data
            let produtosAux: any[] = produtos.map((prod: any, index: any) => (
                {
                    "value": prod.id_produto,
                    "label": `#${prod.id_produto} ${prod.descricao}`
                }
            ))
            produtosAux.unshift({ value: 0, label: "Não Selecionado" })
            setProdutosOptions(produtosAux)
            let unidades = apiUnidades.data
            let unidadesAux: any[] = unidades.map((unid: any, index: any) => (
                {
                    "value": unid.id_unidade,
                    "label": `${unid.descricao}`
                }
            ))
            unidadesAux.unshift({ value: 0, label: "Não Selecionado" })
            setUnidadesOptions(unidadesAux)
            let locais = apiLocais.data
            setFiltroDados({
                produtos: produtos,
                unidades: unidades,
                locais: locais,
            })
        }
        loadOptions()
        // eslint-disable-next-line
    }, [])

    async function loadingPage() {
        setLoading(true)
        await carregarFiltros()
        await carregarPedidos(competencias, statusFiltroSelected, locaisFiltroSelected, colaboradoresFiltroSelected)
        let urlParams:URLSearchParams = getUrlSearchParams()
        const id_pedido = urlParams.get("id")
        if (id_pedido !== null) {
            const dados = { id_pedido: Number(id_pedido) }
            const apiPedido = await reqPostNew(ApiEndpoints.insumosListarPedido, dados)
            if (apiPedido.status === 200) {
                handleOpenPedido(apiPedido.data, false)
            }
        }
        setLoading(false)
    }
    async function carregarFiltros() {
        const api = await reqGetNew(ApiEndpoints.insumosFiltrosPedidos)
        if (api.status === 200) {
            const dados = api.data
            let statusAux = dados.status.map((item: any, index: any) => (
                {
                    "value": `${item.id_status}`,
                    "label": `${item.descricao}`
                }
            ))
            setStatusFiltro(statusAux)
            let locaisAux = dados.locais.map((item: any, index: any) => (
                {
                    "value": `${item.id_local}`,
                    "label": `${item.descricao}`
                }
            ))
            setLocaisFiltro(locaisAux)
            let colsAux = dados.colaboradores.map((item: any, index: any) => (
                {
                    "value": `${item.id_colaborador}`,
                    "label": `${item.matricula} - ${item.nome_completo}`
                }
            ))
            setColaboradoresFiltro(colsAux)
        }
    }
    async function carregarPedidos(meses: any[], status: any[], locais: any[], colaboradores: any[]) {
        const dados = {
            meses: handleParseFiltroPeriodo(meses),
            status: handleParseFiltroIds(status),
            locais: handleParseFiltroIds(locais),
            colaboradores: handleParseFiltroIds(colaboradores),
        }
        // console.log(dados)
        const api = await reqPostNew(ApiEndpoints.insumosPedidosGeral, dados)
        if (api.status === 200) {
            setPedidos(api.data)
        }
    }

    async function handleFiltrarManual(dialogLoaing: boolean) {
        if (dialogLoaing) {
            setLoading(true)
        }
        await carregarPedidos(competencias, statusFiltroSelected, locaisFiltroSelected, colaboradoresFiltroSelected)
        if (dialogLoaing) {
            setLoading(false)
        }
    }
    function handleParseFiltroPeriodo(mes: any) {
        let dados: string[] = []
        if (mes.value === "") {
            return dados
        }
        const PERIODO: string = mes.value
        if (PERIODO.search("-") >= 0) {
            dados.push(PERIODO)
        } else if (PERIODO.search("/") >= 0) {
            const ANO: string = PERIODO.split("/")[1]
            const MES: string = PERIODO.split("/")[0]
            dados.push(`${ANO}-${MES}`)
        }
        return dados
    }
    function handleParseFiltroIds(selecionados: any[]) {
        let dados: number[] = []
        for (let registro of selecionados) {
            dados.push(Number(registro.value))
        }
        return dados
    }
    function handleChangeCompetencia(choice: any) {
        setCompetencias(choice)
    }

    function tableClickhandler(event: any) {
        event.preventDefault()
        event.stopPropagation()

        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = pedidos[idx]
        // console.log(reg)
        if (event.button === 1) {
            window.open(`/insumos/pedidos?id=${reg.id_pedido}`)
        } else {
            handleOpenPedido(reg, true)
        }
    }
    function handleCloseModalPedido() {
        setShowModalPedido(false)
        setPedidoModal({})
        window.history.pushState("OB PORTUS .NET", "OB PORTUS EMPRESA SISTEMA INSUMOS", `/insumos/pedidos`)
    }
    function handleOpenPedido(pedido: any, update_url:boolean) {
        setPedidoModal(pedido)
        setShowModalPedido(true)
        if (update_url) { window.history.pushState("OB PORTUS .NET", "OB PORTUS EMPRESA SISTEMA INSUMOS", `/insumos/pedidos?id=${pedido.id_pedido}`) }
    }

    return (
        <div id="main">
            <LoadingModal show={loading} handleClose={(event: any) => {
                setLoading(!loading)
            }} />

            {
                showModalPedido && <InsumosModalPedido show={showModalPedido} _pedido={pedidoModal} filtrosDados={filtrosDados} handleClose={() => handleCloseModalPedido()} unidadesOptions={unidadesOptions} produtosOptions={produtosOptions} onUpdate={() => { handleFiltrarManual(false) }} />
            }
            {
                showModalCriarPedido && <InsumosModalCriarPedido show={showModalCriarPedido} filtrosDados={filtrosDados} handleClose={() => setShowModalCriarPedido(false)} locaisOptions={locaisFiltro} unidadesOptions={unidadesOptions} produtosOptions={produtosOptions} onUpdate={() => { handleFiltrarManual(false) }} />
            }

            <h1 id='titleMain'>Sistema Insumos FAI - Pedidos</h1>

            <br></br>

            <div className="div-row">
                <InsumosFiltroPeriodo competencias={competencias} handleChangeCompetencia={handleChangeCompetencia} />

                <Select name='ids_status' id='ids_status' options={statusFiltro} defaultValue={statusFiltroSelected} placeholder="Status" isMulti closeMenuOnSelect={false} onChange={
                    (choice) => {
                        setStatusFiltroSelected(choice)
                    }
                } styles={styleSelectLocais} />
                <Select name='ids_locais' id='ids_locais' options={locaisFiltro} defaultValue={locaisFiltroSelected} placeholder="Locais" isMulti closeMenuOnSelect={false} onChange={
                    (choice) => {
                        setLocaisFiltroSelected(choice)
                    }
                } styles={styleSelectLocais} />
                <Select name='ids_colaboradores' id='ids_colaboradores' options={colaboradoresFiltro} defaultValue={colaboradoresFiltroSelected} value={colaboradoresFiltroSelected} placeholder="Colaboradores" isMulti closeMenuOnSelect={false} onChange={
                    (choice: any) => {
                        setColaboradoresFiltroSelected(choice)
                    }
                } styles={styleSelectColaboradores} />

                <Button onClick={() => { handleFiltrarManual(true) }} variant='primary' style={{ height: '40px', marginRight: "5px" }} className='div-row-space-between'>Filtrar <span className="material-symbols-outlined">filter_alt</span></Button>
                <Button onClick={() => { setShowModalCriarPedido(true) }} variant='success' style={{ height: '40px' }} className='div-row-space-between'>Cadastrar <span className="material-symbols-outlined">add</span></Button>
            </div>

            <br></br>

            <DataTable dados={pedidos} tableSize={'auto'} defaultColumns={defaultColumns} tableMiddleClickhandler={tableClickhandler} tableClickhandler={tableClickhandler} defaultOrder={defaultOrder} defaultRows={23} />
        </div>
    )
}

const columnHelper = createColumnHelper<any>()

const defaultColumns = [
    columnHelper.accessor(row => `${dayjs(row.data_criacao).format("DD/MM/YYYY HH:mm:ss")} #${row.id_pedido}`, {
        header: 'Criado em',
        size: 200,
    }),
    // columnHelper.accessor(row => `${row.id_status.descricao}`, {
    //     header: 'Status',
    //     size: 150,
    // }),
    columnHelper.accessor(row => `${row.id_status.descricao}`, {
        header: 'Status',
        size: 150,
        cell: ({ row }: any) => {
            let background = "#264653"
            if (row.original.id_status.id_status === 2) {
                background = "green"
            }
            if (row.original.id_status.id_status === 3) {
                background = "red"
            }
            return (
                // <div style={{backgroundColor: background}}>
                <div about={String(row.index)}>
                    <p about={String(row.index)} style={{ color: "white", backgroundColor: background, position: "relative", top: "0", padding: "5px", width: "max-content", fontWeight: "bold", }}>{row.original.id_status.descricao}</p>
                </div>
            )
        },
    }),
    columnHelper.accessor(row => `${row.id_local.descricao}`, {
        header: 'Local',
        size: 200,
    }),
    columnHelper.accessor(row => `${row.produtos.length} Produtos`, {
        header: 'Quantidade',
        size: 200,
    }),
    columnHelper.accessor(row => `#${row.id_colaborador.matricula} - ${row.id_colaborador.nome_completo}`, {
        header: 'Colaborador',
        size: 500,
    }),
    columnHelper.accessor(row => row.observacao, {
        header: 'Observação',
        size: 300,
    }),
]

const defaultOrder: any[] = []

const styleSelectLocais = {
    control: (baseStyles: any, state: any) => ({
        ...baseStyles,
        width: '250px',
        borderColor: "#dee2e6",
        minHeight: '39px',
        maxHeight: '120px',
        marginRight: '5px',
        fontSize: '14px'
    }),
    valueContainer: (provided: any, state: any) => ({
        ...provided,
        minHeight: '30px',
        maxHeight: '120px',
        overflowY: 'auto',
        fontSize: '14px'
    }),
    input: (provided: any, state: any) => ({
        ...provided,
        margin: '0px',
        fontSize: '14px'
    }),
    indicatorSeparator: (state: any) => ({
        display: 'none',
        fontSize: '14px'
    }),
    indicatorsContainer: (provided: any, state: any) => ({
        ...provided,
        minHeight: '39px',
        maxHeight: '120px',
        fontSize: '14px'
    }),
    menu: (provided: any, state: any) => ({
        ...provided,
        fontSize: '14px'
    }),
}

const styleSelectColaboradores = {
    control: (baseStyles: any, state: any) => ({
        ...baseStyles,
        width: '400px',
        borderColor: "#dee2e6",
        minHeight: '39px',
        maxHeight: '120px',
        marginRight: '5px',
        fontSize: '14px'
    }),
    valueContainer: (provided: any, state: any) => ({
        ...provided,
        minHeight: '30px',
        maxHeight: '120px',
        overflowY: 'auto',
        fontSize: '14px'
    }),
    input: (provided: any, state: any) => ({
        ...provided,
        margin: '0px',
        fontSize: '14px'
    }),
    indicatorSeparator: (state: any) => ({
        display: 'none',
        fontSize: '14px'
    }),
    indicatorsContainer: (provided: any, state: any) => ({
        ...provided,
        minHeight: '39px',
        maxHeight: '120px',
        fontSize: '14px'
    }),
    menu: (provided: any, state: any) => ({
        ...provided,
        fontSize: '14px'
    }),
}
